export default "__VITE_ASSET__fbac9d06__"